import { Check, ChevronDown, ChevronUp, Download, Edit3, FileText, MessageSquare, Plus, Save, Search, StickyNote, Trash2, Upload, X } from 'lucide-react'
import React, { useRef, useState } from 'react'
import Button from './Button'
import Input from './Input';
import { Textarea } from './Textarea';
import Help from '../constant/help';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';
import ReactMarkdown from 'react-markdown';

export default function RightSidebar(props) {
    const {activeRightSection, setActiveRightSection, fileInputRef, documentFiles, handleFileUpload, handleSelect, handleDeleteDocument, selectedFileForChat, noteList, newNoteTitle, setNewNoteTitle, newNoteContent, setNewNoteContent, handleAddNote, handleEditNote, editingNoteId, isAddingNote, setIsAddingNote, handleSaveEditedNote, handleDeleteNote, showRightSidebar, setShowRightSidebar, configChatweb} = props

    const { t } = useTranslation();

    const rightSidebarFileInputRef = useRef(null);

    // const fileInputRef = useRef(null);
    const [fileSearchQuery, setFileSearchQuery] = useState("")

    const [showDocConfirm, setShowDocConfirm] = useState(false);
    const [showNoteConfirm, setShowNoteConfirm] = useState(false);
    const [selectedDocIdToDelete, setSelectedDocIdToDelete] = useState(null);
    const [selectedNoteIdToDelete, setSelectedNoteIdToDelete] = useState(null);
    // const [selectedDocId, setSelectedDocId] = useState(null);

    const [expandedNoteId, setExpandedNoteId] = useState(null);


    const getFilteredAndSortedFiles = () => {
        let filtered = documentFiles;
        // Lọc theo tiêu đề file
        if (fileSearchQuery.trim()) {
            const keyword = fileSearchQuery.toLowerCase();
            filtered = filtered.filter( 
            (file) => file.title.toLowerCase().includes(keyword)
            );
        }
        return filtered;
    };

    const handleDownload = (file) => {
        if (file.url) {
            // Cách tải file
            const link = document.createElement('a');
            link.href = file.url; 
            link.download = decodeURIComponent(file.title); 
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('Không có URL tải xuống cho file này');
        }
    }

  return (
    <div className='w-80 bg-white border-l border-gray-200 flex flex-col h-full'>
        {/* Header */}
        <div className='p-4 border-b border-gray-200 flex justify-between items-center'>
            <h3 className="text-sm font-semibold text-gray-900">
                {t('right_sidebar.title_header')}
            </h3>
            {showRightSidebar !== false && (
                // <X className='h-4 w-4'/>
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {  
                        setShowRightSidebar(false);
                    }}
                        className="h-8 w-8 p-0 text-bg-500"
                    >
                        <X className='h-4 w-4'/>
                </Button>
            )}   
        </div>

        {/* Collapsible Sections */}
        <div className='flex-1 overflow-hidden flex flex-col'>
            <div className='border-b border-gray-200'>
                <button 
                    onClick={() => setActiveRightSection(activeRightSection === "documents" ? null : "documents")}
                    className='w-full p-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors' 
                    >
                    <div className='flex items-center space-x-3'>
                        <FileText className='h-4 w-4 text-gray-600'/>
                        <span className='text-sm font-medium text-gray-900'>
                            {t('right_sidebar.manage_document.document')}
                        </span>

                        {documentFiles?.length > 0 && (
                            <span className="px-2 py-1 bg-blue-100 text-blue-600 text-xs rounded-full">
                                {documentFiles?.length}
                            </span>
                        )}
                    </div>
                     <ChevronDown
                        className={`h-4 w-4 text-gray-400 transition-transform ${
                        activeRightSection === "documents" ? "rotate-180" : ""
                        }`}
                    />
                </button>

                {activeRightSection === "documents" && (
                    <div className="px-4 pb-4 flex-1 overflow-y-auto">
                        {/* 1. Ref đến input ẩn */}
                        <input
                        type="file"
                        accept=".pdf,.doc,.docx,.txt,.html,.xls,.xlsx,.csv"
                        multiple
                        onChange={(e) => {handleFileUpload(e.target.files, false); e.target.value = "";}}
                        className="hidden"
                        // ref={fileInputRef}
                        ref={rightSidebarFileInputRef}
                        />

                        {/* 2. Button để trigger click vào input */}
                        <Button
                            variant="outline"
                            size="sm"
                            className="w-full mb-3 text-sky-600 border-sky-300 hover:bg-sky-50 bg-transparent"
                            onClick={() => rightSidebarFileInputRef.current.click()}
                            >
                            <Upload className="h-3 w-3 mr-2" />
                                {t('right_sidebar.manage_document.upload_document')}
                        </Button>

                        {/* Search Files */}
                        {documentFiles.length > 0 && (
                            <div className="mb-3">
                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-400" />
                                    <Input
                                        value={fileSearchQuery}
                                        onChange={(e) => setFileSearchQuery(e.target.value)}
                                        placeholder={t('right_sidebar.manage_document.search_document')}
                                        className="rounded-md pl-8 h-8 text-xs border-gray-300 focus:border-sky-400"
                                    />
                                </div>
                            </div>
                        )}
                        
                        {documentFiles.length === 0 ? (
                        <div className="text-center py-6 border-2 border-dashed border-gray-300 rounded-lg">
                            <Upload className="h-8 w-8 text-gray-400 mx-auto mb-2" />
                            <p className="text-xs text-gray-500">{t('right_sidebar.manage_document.no_document')}</p>
                        </div>
                        ) : (
                            <div className='space-y-2 overflow-scroll max-h-72'>
                                {getFilteredAndSortedFiles().map((file) => (
                                    
                                    <div
                                        key={file.id}
                                        onClick={() => handleSelect(file.id)}
                                        className={`p-2 rounded-lg border transition-all duration-200 cursor-pointer hover:bg-violet-50 hover:border-violet-200 ${
                                        selectedFileForChat?.id === file.id
                                            ? "bg-violet-100 border-violet-300 shadow-sm"
                                            : "bg-white border-gray-200"
                                        }`}
                                    >
                                        <div className='flex items-center space-x-2'>
                                            <div
                                                className={`w-6 h-6 rounded flex items-center justify-center flex-shrink-0 ${
                                                    file.status === "ready"
                                                    ? "bg-green-100"
                                                    : file.status === "uploading"
                                                        ? "bg-yellow-100"
                                                        : file.status === "analyzing"
                                                        ? "bg-blue-100"
                                                        : "bg-red-100"
                                                }`}
                                                >
                                                {file.status === "uploading" ? (
                                                    <div className="w-2 h-2 border border-yellow-600border-t-transparent rounded-full animate-spin" />
                                                ) : file.status === "analyzing" ? (
                                                    <div className="w-2 h-2 border border-blue-600 border-t-transparentrounded-full animate-spin" />
                                                ) : (
                                                    <FileText
                                                    className={`h-3 w-3 ${file.status === "ready" ? "text-green-600" :"text-red-600"}`}
                                                    />
                                                )}
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex items-center justify-between">
                                                    <h6 className="text-xs font-medium text-gray-800 truncate pr-2">{decodeURIComponent(file.title)}</h6>
                                                    
                                                    {/* <h6 className="text-xs font-medium text-gray-800 truncate pr-2">{Help.getFileNameFromUrl(file.url)}</h6> */}
                                                    {selectedFileForChat?.id === file.id && (
                                                        <div className="w-2 h-2 bg-violet-500 rounded-full flex-shrink-0" />
                                                    )}
                                                </div>

                                                <div className="flex items-center space-x-2 text-xs text-gray-500 mt-0.5">
                                                    <span>{Help.formatFileSize(file.size)}</span>
                                                    <span>•</span>
                                                    <span>{Help.formatCreatedAt(file.createdAt)}</span>

                                                </div>     
                                            </div>
                                            <div className="flex items-center space-x-1">
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        handleDownload(file)
                                                    }}
                                                >
                                                    <Download className="h-3 w-3" />
                                                </Button>
                                                <Button
                                                    variant="ghost"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        //{handleDeleteDocument(file.id)};
                                                        setSelectedDocIdToDelete(file.id);
                                                        setShowDocConfirm(true);
                                                    }}
                                                    className="h-6 w-6 p-0 text-gray-400 hover:text-red-600"
                                                >
                                                    <Trash2 className="h-3 w-3" />
                                                </Button>

                                            </div>
                                        </div>

                                        {selectedFileForChat?.id === file.id && (
                                            <div className="mt-2 pt-2 border-t border-violet-200">
                                                <div className="flex items-center justify-center text-xs text-violet-700 font-medium">
                                                    <Check className="h-3 w-3 mr-1" />
                                                    {t('right_sidebar.manage_document.being_analyzed')}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {/* No search results */}
                                {fileSearchQuery.trim() && getFilteredAndSortedFiles().length === 0 && (
                                <div className="text-center py-4">
                                    <Search className="h-6 w-6 text-gray-400 mx-auto mb-2" />
                                    <p className="text-xs text-gray-500">{t('right_sidebar.manage_document.not_found_document')}</p>
                                </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
                <ConfirmDialog
                    open={showDocConfirm}
                    title={t('right_sidebar.manage_document.confirm_delete_doc.title')}
                    message={t('right_sidebar.manage_document.confirm_delete_doc.message')}
                    onCancel={() => {
                        setShowDocConfirm(false);
                        setSelectedDocIdToDelete(null);
                    }}
                    onConfirm={() => {
                        if (selectedDocIdToDelete) {
                            handleDeleteDocument(selectedDocIdToDelete);
                        }
                        setShowDocConfirm(false);
                        setSelectedDocIdToDelete(null);
                    }}
                />
            </div>

            {/* Notes Section */}
            <div className='border-b border-gray-200'>
                <button className='w-full p-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors' onClick={() => setActiveRightSection(activeRightSection === "notes" ? null : "notes")}>
                    <div className='flex items-center space-x-3'>
                        <StickyNote className='h-4 w-4 text-gray-600 text-current'/>
                        <span className='text-sm font-medium text-gray-900'>{t('right_sidebar.manage_note.note')}</span>
                        {noteList?.length > 0 && (
                            <span className="px-2 py-1 bg-yellow-100 text-yellow-600 text-xs rounded-full">{noteList?.length}</span>
                        )}
                    </div>
                    <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform text-current ${activeRightSection === "notes" ? "rotate-180" : ""
                    }`}/>
                </button>
                {activeRightSection === "notes" && (
                    <div className="px-4 pb-4 max-h-96 overflow-y-auto">
                        <Button
                            variant="outline"
                            size="sm"
                            className="w-full mb-3 border-yellow-300 text-yellow-600 hover:bg-yellow-50"
                            onClick={() => setIsAddingNote(true)}
                        >
                            <Plus className="h-3 w-3 mr-2" />
                                {t('right_sidebar.manage_note.add_note')}
                        </Button>

                        {/* Add/Edit Note Form */}
                        {isAddingNote && (
                            <div className="mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                                <Input
                                    value={newNoteTitle}
                                    onChange={(e) =>  setNewNoteTitle(e.target.value)}
                                    placeholder={t('right_sidebar.manage_note.input_note_title')}
                                    className="mb-2 text-sm h-8"
                                />
                                <Textarea
                                    value={newNoteContent}
                                    onChange={(e) => setNewNoteContent(e.target.value)}
                                    placeholder={t('right_sidebar.manage_note.input_note_content')}
                                    className="mb-2 text-sm min-h-[60px]"
                                />
                                <div className="flex space-x-2">
                                <Button
                                    size="sm"
                                    onClick={editingNoteId ? handleSaveEditedNote : handleAddNote}
                                    // onClick={handleAddNote}
                                    className="bg-yellow-500 hover:bg-yellow-600 text-white h-7 text-xs"
                                >
                                    <Save className="h-3 w-3 mr-1" />
                                    {t('right_sidebar.manage_note.save_note')}
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline"
                                    onClick={() => {
                                        setIsAddingNote(false)
                                        // setEditingNoteId(null)
                                        setNewNoteTitle("")
                                        setNewNoteContent("")
                                    }}
                                    className="h-7 text-xs"
                                >
                                    <X className="h-3 w-3 mr-1" />
                                    {t('right_sidebar.manage_note.cancel_note')}
                                </Button>
                                </div>
                            </div>
                        )} 
                        
                        {noteList?.length === 0 ? (
                            <div className="text-center py-6">
                                <StickyNote className="h-8 w-8 text-gray-300 mx-auto mb-2" />
                                <p className="text-xs text-gray-500"> {t('right_sidebar.manage_note.no_note')}</p>
                            </div>
                        ):(
                           <div className="space-y-2">
                            {noteList?.map((note) => (
                            <div key={note.id} className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 group">
                                <div className="flex items-start justify-between mb-2">
                                    <h4 className="text-xs font-medium text-gray-800 truncate flex-1">{note.title}</h4>
                                    <div className="flex items-center space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={() => handleEditNote(note.id)}
                                            className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                                        >
                                            <Edit3 className="h-3 w-3" />
                                        </Button>
                                        <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={(e) => {
                                                    e.stopPropagation();
                                                    setSelectedNoteIdToDelete(note.id);
                                                    setShowNoteConfirm(true);
                                                }
                                            }
                                            className="h-5 w-5 p-0 text-gray-400 hover:text-red-600"
                                        >
                                            <Trash2 className="h-3 w-3" />
                                        </Button>
                                    </div>
                                </div>
                                {/* <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                                    {note.content}
                                    </p> */}
                                <div className="text-xs text-gray-600 mb-2 whitespace-pre-wrap break-words">
                                    {/* <ReactMarkdown>{note.content}</ReactMarkdown> */}
                                    <div className={expandedNoteId === note.id ? "" : "line-clamp-2"}>
                                        {/* <ReactMarkdown>{Help.formatMessageNote(note.content)}</ReactMarkdown> */}
                                        {/* {Help.formatMessageNote(note.content)} */}
                                        <ReactMarkdown
                                            components={{
                                                h3: ({ node, ...props }) => (
                                                    <h3 className="text-xs font-medium mb-1" {...props} />
                                                ),
                                            }}         
                                        >
                                            {Help.formatMessageNote(note.content)}
                                        </ReactMarkdown>  
                                    </div>
                                    {note.content.length > 100 && ( // điều kiện nếu dài mới hiện nút
                                        <button
                                            onClick={() =>
                                                setExpandedNoteId(expandedNoteId === note.id ? null : note.id)
                                            }
                                            className="text-blue-500 text-xs mt-1 hover:underline"
                                        >
                                            <div className='flex justify-between items-center'>
                                                {expandedNoteId === note.id ? t("right_sidebar.manage_note.collapse") : t("right_sidebar.manage_note.see_more")}
                                                {expandedNoteId === note.id ? (
                                                    <ChevronUp className="h-3 w-3" />
                                                ) : (
                                                    <ChevronDown className="h-3 w-3" />
                                                )}
                                            </div>
                                            
                                        </button>
                                    )}
                                </div>
                                <div className="flex items-center justify-end">
                                {/* <div className="flex items-center space-x-1">
                                    {note.tags.slice(0, 2).map((tag) => (
                                    <span key={tag} className="px-1 py-0.5 bg-yellow-200 text-yellow-800 text-xs rounded">
                                        {tag}
                                    </span>
                                    ))}
                                </div> */}
                                <p className="text-xs text-gray-400">
                                    {Help.formatCreatedAt(note.createdAt)}
                                </p>
                                </div>
                            </div>
                            ))}
                        </div>
                        )}  
                        <ConfirmDialog
                            open={showNoteConfirm}
                            title={t('right_sidebar.manage_note.confirm_delete_note.title')}
                            message={t('right_sidebar.manage_note.confirm_delete_note.message')}
                            onCancel={() => {
                                setShowNoteConfirm(false);
                                setSelectedNoteIdToDelete(null);
                            }}
                            onConfirm={() => {
                                if (selectedNoteIdToDelete) {
                                handleDeleteNote(selectedNoteIdToDelete);
                                }
                                setShowNoteConfirm(false);
                                setSelectedNoteIdToDelete(null);
                            }}
                        />
                    </div>
                )}
            </div>

            {/* Help Section - Always at bottom */}
            <div className='mt-auto px-4 py-3 border-t border-gray-200 bg-gray-50 h-[115px] flex flex-col justify-center'>
                <h4 className='text-sm font-medium text-gray-900 mb-1'> {t('right_sidebar.help.question')}</h4>
                <p className='text-xs text-gray-600 mb-2 truncate'>
                    {t('right_sidebar.help.description')}
                </p>
                <Button variant="outline" size="sm" className="w-full text-xs h-8 bg-transparent"
                    onClick={() => {
                        window.location.href = `tel:${configChatweb.phone}`;
                    }}>
                   {t('right_sidebar.help.contact')}
                </Button>
            </div>
        </div>
    </div>
  )
}
